import { Component, Input, OnInit, ChangeDetectorRef, SimpleChanges, Inject, Optional } from '@angular/core';
import { EventEmitter } from '@angular/core';
import { Output, OnChanges } from '@angular/core';
import { consts } from '../../../consts';
import { AddFileService } from '../../../shared/components/add-file/add-file.service';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { AccountingAccountsModel } from '../../accounting/accounting-accounts/accounting-accounts.model';
import { InvestmentInCompaniesModel } from './investment-incompanies.model';
import { AccountMovementsViewModel } from '../../accounting/models/accounting-movement.model';
import { InvestmentInCompaniesService } from './investment-incompanies.service';
import { AccountingAccountsService } from '../../accounting/accounting-accounts/accounting-accounts.service';
import { AccountingMovementsImportComponent } from '../../accounting/movements/import/accounting-movements-import.component';
import { SharedService } from '../../../shared/services/shared.service';
import { InvestmentInCompaniesDialogImportAccount } from './investmentInCompanies-dialog-importAccount.component';

@Component({
    selector: 'convfact-investment-incompanies-form',
    templateUrl: './investment-incompanies-form.component.html',
    styleUrls: ['./investment-incompanies.component.css'],
    standalone: false
})
export class InvestmentInCompaniesFormComponent implements OnInit, OnChanges {

  @Input() investmentInCompanies: InvestmentInCompaniesModel;
  @Output() onSave = new EventEmitter<any>();
  @Input() errors: object;
  @Input() accounts: AccountingAccountsModel[];

  public originEntity: string = consts.INVESTMENT_ENTITY;
  public filePath: string = consts.INVESTMENT_FILE_PATH;

  public loading = false;
  public ready = false;

  public imageTempUrl: any = '';

  public readyLoadedFiles: boolean = null;

  //AccountMovementes Import data
  flagImport: boolean = false;
  movement: AccountMovementsViewModel;
  type: string;
  saved: boolean = false;
  //------------------------------
  accountsAccounting: AccountingAccountsModel[] = [];

  constructor(
    private addFileService: AddFileService,
    public snackBar: MatSnackBar,
    private ref: ChangeDetectorRef,
    private investmentInCompaniesService: InvestmentInCompaniesService,
    private accountingAccountsService: AccountingAccountsService,
    private sharedService: SharedService,
    public dialog: MatDialog,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    @Optional() public dialogRefImport: MatDialogRef<AccountingMovementsImportComponent>
  ) { }

  public ngOnInit(): void {
    if (this.data != null) {

      this.investmentInCompaniesService.accounts()
        .then(data => {
          this.accountsAccounting = data as any;
          this.movement = this.data.movement;
          this.flagImport = this.data.flagImport;
          this.type = this.data.type;
          this.movement.type = this.type;
          this.investmentInCompanies.manualMovement = this.movement;
          this.investmentInCompanies.investmentDate = this.movement.date;
          this.investmentInCompanies.investmentValue = this.movement.amount;

          this.sharedService.checkIfAccountNumberExists(this.movement.accountNumber, this.movement.type).then(response => {
            this.investmentInCompanies.manualMovement.accountNumber = response;
            this.investmentInCompanies.accountingModelsNumber = response;
            const accountNumber = this.accountsAccounting
              .find(x => x.number == this.investmentInCompanies.accountingModelsNumber);

            this.investmentInCompanies.accountingModelsId = Number(accountNumber.id);
          })

        })
    }

    this.ready = true;
  }

  closeDialog() {
    this.dialogRefImport.close(this.saved);
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.investmentInCompanies && changes.investmentInCompanies.currentValue.isPdf != undefined) {
      if (this.investmentInCompanies.isPdf) {
        this.readyLoadedFiles = false;
        this.addFileService.getImageFromFilesPDF(this.investmentInCompanies.filesInvestmentUid, this.originEntity).then(result => {
          this.loadPdfBlob(result);
          this.readyLoadedFiles = true;
        });
      }
    }
    if (changes.investmentInCompanies && changes.investmentInCompanies.currentValue.isImage != undefined) {
      if (this.investmentInCompanies.isImage) {
        this.readyLoadedFiles = false;
        this.addFileService.getImageFromFiles(this.investmentInCompanies.filesInvestmentUid, this.originEntity).then(response => {
          this.createImageFromBlob(response);
          this.readyLoadedFiles = true;
        })
      }
    }
  }

  public save(): void {
    this.loading = true;
    let noError = true;

    if (this.investmentInCompanies.accountingModelsId == null) {
      noError = false;
      this.loading = false;
      this.displayInfo("Es necesario seleccionar una de las opciones del campo 'Tipo inversion'");
    }

    if (this.investmentInCompanies.investmentValue == null) {
      noError = false;
      this.loading = false;
      this.displayInfo("El campo 'Valor de inversion' es requerido");
    }

    if (this.investmentInCompanies.investmentValue <= 0) {
      noError = false;
      this.loading = false;
      this.displayInfo("El valor de la inversion no puede ser menor o igual a 0");
    }

    if (this.investmentInCompanies.investmentDate == null) {
      noError = false;
      this.loading = false;
      this.displayInfo("El campo 'fecha de inversión' es requerido");
    }

    if (this.investmentInCompanies.investmentDescription == null || this.investmentInCompanies.investmentDescription == '') {
      noError = false;
      this.loading = false;
      this.displayInfo("El campo 'Descripción' es requerido");
    }

    this.setDefaultsValues();

    if (noError) {
      if (this.data != null) {
        this.investmentInCompaniesService.add(this.investmentInCompanies)
          .then(response => {
            this.saved = true;
          },
            error => {
              //Si venimos de importar, y ya existe la inversión, preguntamos si queremos actualizar
              //la inversión ya existente
              if (error.error['message'].includes("ya se encuentra registrada") && this.data != null) {
                this.dialog.open(InvestmentInCompaniesDialogImportAccount, {
                  // width: '20%',
                  //height: '40%',
                  data: {
                    dataImport: this.investmentInCompanies,
                  }
                }).afterClosed().subscribe(result => this.closeDialog())
              } else {
                this.displayInfo(error.error['message']);
              }
            });
      } else {
        this.onSave.emit(this.investmentInCompanies);
        this.loading = false;
      }
    }
  }

  public createImageFromBlob(image: Blob): void {
    const reader = new FileReader();
    if (image) {
      reader.readAsDataURL(image);
      reader.onloadend = () => {
        this.imageTempUrl = reader.result;
        this.ref.detectChanges();
      }
      this.ref.detectChanges();
    }
  }

  public loadPdfBlob(data: Blob): void {
    this.imageTempUrl = data;
    this.ref.detectChanges();
  }

  public SetFileParameters(event): void {
    this.imageTempUrl = null;
    this.investmentInCompanies.isImage = event.Image;
    this.investmentInCompanies.isPdf = event.PDF;
    this.investmentInCompanies.filesInvestmentUid = event.FileUid;

    if (event.File) {
      this.createImageFromBlob(event.File);
    }

    if (event.PDF) {
      this.loadPdfBlob(event.File);
    }
  }

  public setDefaultsValues(): void {
    if (this.investmentInCompanies.netBookValue == null) {
      this.investmentInCompanies.netBookValue = 0;
    }
    if (this.investmentInCompanies.termInMonths == null) {
      this.investmentInCompanies.termInMonths = 0;
    }
    if (this.investmentInCompanies.percentageOfProfitabilityOrInterest == null) {
      this.investmentInCompanies.percentageOfProfitabilityOrInterest = 0;
    }
    if (this.investmentInCompanies.numberOfUnitsOrSharesInvested == null) {
      this.investmentInCompanies.numberOfUnitsOrSharesInvested = 0;
    }
  }

  public changeToggleGeneratesReturns(event: MatSlideToggleChange) {
    if (event.checked) {
      this.investmentInCompanies.generatesReturns = true;
    } else {
      this.investmentInCompanies.generatesReturns = false;
    }
  }

  public checkImage(): void {
    if (this.investmentInCompanies.filesInvestmentUid != null || this.investmentInCompanies.isImage || this.investmentInCompanies.isPdf) {
      this.addFileService.getImageFromFiles(this.investmentInCompanies.filesInvestmentUid, this.originEntity).then(response => {
        this.createImageFromBlob(response);
      })
    }
  }

  public displayInfo(message: string): void {
    const options = new MatSnackBarConfig();
    options.duration = 10000;
    options.panelClass = ['custom-snackbar', 'custom-snackbar-container']; this.snackBar.open(message, '', options);
  }

  public change(value: string) {
    const accountNumber = this.accounts.find(x => x.number === value);

    this.investmentInCompanies.accountingModelsId = Number(accountNumber.id);
  }

}
